var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _path9, _path10, _g2, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _g3, _path40, _path41, _path42, _path43, _g4, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 551,
    height: 539,
    viewBox: "0 0 551 539",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_324_11732",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 0,
    width: 549,
    height: 213
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M421.344 21.3749L550.999 133.096V212.967L314.11 116.926V44.4051L421.344 21.3749Z",
    fill: "#DFECFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M77.549 84.2445L44.8428 79.1954L2.15674 108.106V212.967L314.11 116.926V44.4051L194.97 0.304688L77.549 84.2445Z",
    fill: "#DFECFE"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_324_11732)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M421.344 21.3749L550.999 133.096V212.967L314.11 116.926V44.4051L421.344 21.3749Z",
    fill: "#F2F7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.549 84.2445L44.8428 79.1954L2.15674 108.106V212.967L314.11 116.926V44.4051L194.97 0.304688L77.549 84.2445Z",
    fill: "#F2F7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.417 61.2565L194.981 0.304688L182.213 30.4011L227.078 48.7759L195.091 153.596L83.2922 187.972L110.417 61.2565Z",
    fill: "#DFECFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.1135 85.5654L44.467 79.4351L1.94922 108.106V161.026L55.0961 126.452L73.1135 85.5654Z",
    fill: "#DFECFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.11 44.4051L407.696 24.3149L382.235 60.551L415.468 111.082L393.571 149.026L314.11 116.926V44.4051Z",
    fill: "#DFECFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.298 30.1954L194.971 0.305176L203.258 3.2452L195.876 25.0873L234.851 50.7756L222.393 148.667L186.346 158.721L205.118 50.7756L182.298 30.1954Z",
    fill: "#ACCBF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.298 30.1954L194.971 0.305176L203.258 3.2452L195.876 25.0873L234.851 50.7756L222.393 148.667L186.346 158.721L205.118 50.7756L182.298 30.1954Z",
    fill: "url(#paint0_linear_324_11732)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.333 1.28516L189.438 27.3944M189.438 27.3944L188.993 28.429L216.816 51.7556L195.664 153.95C198.694 153.644 202.029 153.336 205.605 153.036L227.052 51.7556L189.438 27.3944Z",
    stroke: "#7DA7E7",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.572 30.3237L197.806 1.28516L203.168 3.24517L195.876 25.0873L234.851 50.7756L222.393 148.667L186.346 158.721L205.118 50.7756L184.572 30.3237Z",
    fill: "url(#paint1_linear_324_11732)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M239.046 309.007L2.15637 212.967L314.11 116.926L550.999 212.967L239.046 309.007Z",
    fill: "#AADBB7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M239.046 309.007L2.15637 212.967L314.11 116.926L550.999 212.967L239.046 309.007Z",
    fill: "url(#paint2_linear_324_11732)",
    fillOpacity: 0.8
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7197 237.111L79.1547 219.608L193.229 263.677L150.846 273.661L60.7197 237.111Z",
    fill: "url(#paint3_linear_324_11732)",
    fillOpacity: 0.8
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.15723 212.966L239.048 309.007V365.848L2.15723 269.807V212.966Z",
    fill: "url(#paint4_linear_324_11732)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M551 212.966L239.047 309.007V365.848L551 269.815V212.966Z",
    fill: "url(#paint5_linear_324_11732)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M235.505 538.359L0 443.327L312.892 348.295L548.397 443.327L235.505 538.359Z",
    fill: "url(#paint6_radial_324_11732)",
    fillOpacity: 0.75
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 308.474,
    cy: 136.506,
    rx: 37.5917,
    ry: 11.1149,
    fill: "url(#paint7_radial_324_11732)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 107.246,
    cy: 204.863,
    rx: 37.5917,
    ry: 10.5591,
    fill: "url(#paint8_radial_324_11732)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 163.08,
    cy: 182.077,
    rx: 20.4543,
    ry: 5.55743,
    fill: "url(#paint9_radial_324_11732)",
    fillOpacity: 0.5
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 200.673,
    cy: 171.518,
    rx: 20.4543,
    ry: 6.11317,
    fill: "url(#paint10_radial_324_11732)",
    fillOpacity: 0.5
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 437.28,
    cy: 199.86,
    rx: 77.9475,
    ry: 22.2297,
    fill: "url(#paint11_radial_324_11732)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_324_11732",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 182,
    y: 0,
    width: 218,
    height: 414
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M182.299 30.195L194.972 0.304688L203.258 3.24471L195.876 25.0868L234.851 50.7751L222.394 148.667C270.18 146.293 287.029 139.87 320.176 148.667C358.115 158.736 348.144 167.515 382.74 189.302C400.089 200.226 401.551 219.459 397.656 260.497V320.768V381.038L292.855 413.378V293.327C307.965 259.027 317.842 261.355 324.319 244.327C329.476 230.771 342.314 212.963 324.319 196.423C306.089 179.667 303.603 167.518 269.213 166.261C241.701 165.256 209.825 155.928 186.347 158.721L205.118 50.7751L182.299 30.195Z",
    fill: "#ACCBF9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M182.299 30.195L194.972 0.304688L203.258 3.24471L195.876 25.0868L234.851 50.7751L222.394 148.667C270.18 146.293 287.029 139.87 320.176 148.667C358.115 158.736 348.144 167.515 382.74 189.302C400.089 200.226 401.551 219.459 397.656 260.497V320.768V381.038L292.855 413.378V293.327C307.965 259.027 317.842 261.355 324.319 244.327C329.476 230.771 342.314 212.963 324.319 196.423C306.089 179.667 303.603 167.518 269.213 166.261C241.701 165.256 209.825 155.928 186.347 158.721L205.118 50.7751L182.299 30.195Z",
    fill: "url(#paint12_linear_324_11732)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_324_11732)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M269.213 166.261C241.701 165.256 209.825 155.928 186.347 158.721L222.394 148.667C270.18 146.293 287.029 139.87 320.176 148.667C358.115 158.736 348.144 167.516 382.74 189.302C400.089 200.227 401.551 219.459 397.656 260.497V320.768V381.038L292.855 413.378V293.327C307.965 259.027 317.842 261.355 324.319 244.327C329.476 230.771 342.314 212.963 324.319 196.423C306.089 179.667 303.603 167.518 269.213 166.261Z",
    fill: "#ACCBF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.213 166.261C241.701 165.256 209.825 155.928 186.347 158.721L222.394 148.667C270.18 146.293 287.029 139.87 320.176 148.667C358.115 158.736 348.144 167.516 382.74 189.302C400.089 200.227 401.551 219.459 397.656 260.497V320.768V381.038L292.855 413.378V293.327C307.965 259.027 317.842 261.355 324.319 244.327C329.476 230.771 342.314 212.963 324.319 196.423C306.089 179.667 303.603 167.518 269.213 166.261Z",
    fill: "url(#paint13_linear_324_11732)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.47 150.561C293.149 150.908 306.503 148.286 324.095 158.953C343.522 170.733 365.828 182.173 380.104 206.596C385.406 215.666 387.416 243.347 382.055 266.125C380.592 267.847 378.732 345.268 381.169 389.858M269.47 150.561C286.15 153.358 312.419 159.171 322.427 169.846C334.936 183.19 358.879 181.796 366.21 215.3C371.489 239.425 363.493 244.327 355.368 273.631C350.859 289.897 353.873 366.828 353.873 396.228M269.47 150.561C247.431 150.238 223.496 151.533 205.606 153.035C202.029 153.335 198.695 153.644 195.665 153.949C232.498 155.061 291.282 147.639 311.169 172.298C326.975 191.896 351.273 188.438 344.527 237.351C342.859 249.445 334.351 254.617 322.427 283.223C315.764 299.207 319.266 376.138 319.266 406.028",
    stroke: "#7DA7E7",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.213 166.261C241.701 165.256 209.825 155.928 186.347 158.721L222.394 148.667C270.18 146.293 287.029 139.87 320.176 148.667C358.115 158.736 348.144 167.516 382.74 189.302C400.089 200.227 401.551 219.459 397.656 260.497V320.768V381.038L292.855 413.378V293.327C307.965 259.027 317.842 261.355 324.319 244.327C329.476 230.771 342.314 212.963 324.319 196.423C306.089 179.667 303.603 167.518 269.213 166.261Z",
    fill: "url(#paint14_linear_324_11732)"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M101.801 171.703L103.883 171.627L103.99 176.386L104.663 176.728L104.809 182.417L106.695 183.107L106.174 200.366L104.809 200.121L100.319 199.246L88.9192 164.829L92.5525 170.468L100.926 178.245L101.092 174.745L101.517 174.986L101.801 171.703Z",
    fill: "#AADBB7"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M101.801 171.703L103.883 171.627L103.99 176.386L104.663 176.728L104.809 182.417L106.695 183.107L106.174 200.366L104.809 200.121L100.319 199.246L88.9192 164.829L92.5525 170.468L100.926 178.245L101.092 174.745L101.517 174.986L101.801 171.703Z",
    fill: "url(#paint15_linear_324_11732)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M101.729 171.634H103.876L103.99 176.386L104.664 176.743L104.807 182.287L106.71 183.103L106.174 200.366L104.809 200.121L104.956 189.718L100.696 183.107L92.5525 170.468L100.926 178.245L101.105 174.766L101.517 174.986L101.729 171.634Z",
    fill: "#48A7A1"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M104.809 200.121L104.956 189.718L100.696 183.107L92.5525 170.468L100.926 178.245L100.696 183.107L104.956 189.718L104.807 182.287L106.71 183.103L106.174 200.366L104.809 200.121Z",
    fill: "#48A7A1"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M104.809 200.121L104.956 189.718L100.696 183.107L92.5525 170.468L100.081 181.24L100.325 177.687L100.926 178.245L100.742 182.124L104.956 187.762L104.809 182.27L105.752 182.688L105.248 200.2L104.809 200.121Z",
    fill: "#25938C"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M101.517 174.986L103.99 176.386L103.981 175.992L101.544 174.57L101.517 174.986Z",
    fill: "#25938C"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M101.903 171.634L94.3294 166.464L92.7837 158.217L94.7158 153.356L96.0683 156.078L99.5848 150.245L100.705 151.801L101.478 150.44L104.376 153.616L104.57 152.52H106.115L110.366 160.356L103.758 171.634H101.903Z",
    fill: "#F6E4A1"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M100.705 151.801L103.99 156.078L104.376 153.616L101.478 150.44L100.705 151.801Z",
    fill: "#EBC644"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M103.793 171.634H101.938L100.75 170.823L103.507 171.088L102.563 169.284L96.1032 156.078L96.5746 155.296L102.344 167.95L103.424 155.296L100.74 151.801L100.847 151.612L103.511 154.586L103.723 152.844L104.411 153.616L104.148 155.296L104.025 156.078L102.6 168.955L103.998 171.284L103.793 171.634Z",
    fill: "#EBC644"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M275.3 165.881L273.596 165.819L273.509 169.721L272.958 170.001L272.839 174.666L271.296 175.232L271.722 189.385L272.839 189.184L276.513 188.466L285.84 160.244L282.867 164.868L276.016 171.246L275.881 168.376L275.533 168.573L275.3 165.881Z",
    fill: "#AADBB7"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M275.3 165.881L273.596 165.819L273.509 169.721L272.958 170.001L272.839 174.666L271.296 175.232L271.722 189.385L272.839 189.184L276.513 188.466L285.84 160.244L282.867 164.868L276.016 171.246L275.881 168.376L275.533 168.573L275.3 165.881Z",
    fill: "url(#paint16_linear_324_11732)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M275.359 165.825H273.602L273.509 169.721L272.958 170.014L272.841 174.56L271.283 175.229L271.722 189.385L272.839 189.184L272.719 180.653L276.204 175.232L282.867 164.868L276.016 171.246L275.87 168.393L275.533 168.573L275.359 165.825Z",
    fill: "#48A7A1"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M272.839 189.184L272.719 180.653L276.204 175.232L282.867 164.868L276.016 171.246L276.204 175.232L272.719 180.653L272.841 174.56L271.283 175.229L271.722 189.385L272.839 189.184Z",
    fill: "#48A7A1"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M272.839 189.184L272.719 180.653L276.204 175.232L282.867 164.868L276.707 173.701L276.508 170.788L276.016 171.246L276.166 174.427L272.719 179.05L272.839 174.546L272.067 174.889L272.48 189.248L272.839 189.184Z",
    fill: "#25938C"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M275.533 168.573L273.509 169.721L273.517 169.398L275.511 168.232L275.533 168.573Z",
    fill: "#25938C"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M275.216 165.825L281.413 161.585L282.678 154.823L281.097 150.837L279.99 153.069L277.113 148.286L276.196 149.561L275.564 148.445L273.193 151.05L273.035 150.151H271.77L268.292 156.577L273.699 165.825H275.216Z",
    fill: "#FBE6DC"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M276.196 149.561L273.509 153.069L273.193 151.05L275.564 148.445L276.196 149.561Z",
    fill: "#FFB1B1"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M273.67 165.825H275.188L276.16 165.159L273.904 165.377L274.676 163.898L279.962 153.069L279.576 152.428L274.856 162.803L273.972 152.428L276.168 149.561L276.08 149.407L273.901 151.845L273.727 150.417L273.164 151.05L273.38 152.428L273.481 153.069L274.647 163.627L273.502 165.538L273.67 165.825Z",
    fill: "#FFB1B1"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M213.701 298.717C226.374 304.107 220.525 301.657 237.097 308.027C239.047 309.497 248.795 305.577 256.594 303.617C248.308 300.677 249.364 298.227 235.635 298.227C221.906 298.227 213.701 295.199 213.701 298.717Z",
    fill: "url(#paint17_radial_324_11732)",
    fillOpacity: 0.4
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6794 220.548C33.3525 225.938 27.5034 223.488 44.0759 229.858C46.0256 231.328 55.7742 227.408 63.573 225.448C55.2867 222.508 56.3428 220.058 42.6136 220.058C28.8845 220.058 20.6794 217.03 20.6794 220.548Z",
    fill: "url(#paint18_radial_324_11732)",
    fillOpacity: 0.4
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M276.579 266.376C278.041 260.006 278.041 250.038 294.613 243.668C296.563 242.198 304.154 244.986 304.642 247.267C295.381 265.887 294.406 268.337 284.865 271.766C280.758 270.296 278.808 271.765 276.579 266.376Z",
    fill: "url(#paint19_radial_324_11732)",
    fillOpacity: 0.4
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M411.876 250.593C415.078 242.856 418.212 239.426 423.617 230.847C424.97 229.568 430.547 234.012 430.885 235.996C428.936 241.386 427.143 255.28 417.622 255.28C414.58 257.837 408.951 258.046 411.876 250.593Z",
    fill: "url(#paint20_radial_324_11732)",
    fillOpacity: 0.4
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M528.284 212.579C525.656 218.119 525.656 226.786 495.88 232.325C492.377 233.604 479.835 228.82 476.91 226.196C471.548 218.846 488.728 207.892 513.395 207.892C521.277 205.335 533.538 204.484 528.284 212.579Z",
    fill: "url(#paint21_radial_324_11732)",
    fillOpacity: 0.4
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M329.985 154.746C330.988 151.049 330.988 145.264 342.355 141.568C343.693 140.715 348.481 143.907 349.597 145.658C351.644 150.563 345.086 157.874 335.669 157.874C332.66 159.58 327.979 160.148 329.985 154.746Z",
    fill: "url(#paint22_radial_324_11732)",
    fillOpacity: 0.4
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M306.623 219.671L192.633 55.271L78.6429 219.79L127.834 238.929L192.633 263.892L260.27 238.929L306.623 219.671Z",
    fill: "#AADBB7"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M192.633 55.271L78.6428 219.79L127.834 238.929L192.633 263.892V55.271Z",
    fill: "#48A7A1"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M127.834 238.932L192.633 263.895L260.27 238.932L306.623 219.674L290.633 196.613L243.547 193.523L192.633 232.869L145.334 189.243H99.8101L78.6429 219.793L127.834 238.932Z",
    fill: "#125867"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M260.27 238.931L306.623 219.674L290.633 196.613L239.459 182.348L192.633 216.108V263.895L260.27 238.931Z",
    fill: "#48A7A1"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M127.833 238.929L192.632 55.2715L260.27 238.929",
    stroke: "#25938C",
    strokeWidth: 1.5,
    strokeLinejoin: "bevel"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_324_11732)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M245.606 128.193L192.513 52.3018L139.775 128.618L156.921 112.927L154.614 140.091L171.938 108.053V141.575L183.172 113.759L189.202 129.569L193.878 105.649L201.357 148.232L205.757 113.759L215.068 135.707L214.034 105.649L235.555 139.316L226.214 110.668L245.606 128.193Z",
    fill: "#FEFEFE"
  }))), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M189.202 129.569L193.878 105.649L192.513 52.3018L139.775 128.618L156.921 112.927L154.614 140.091L171.938 108.053V141.575L183.172 113.759L189.202 129.569Z",
    fill: "#C7DBF5"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M306.622 219.67L192.632 55.271L78.6427 219.789L127.833 238.927L192.632 263.89L260.269 238.927L306.622 219.67Z",
    fill: "url(#paint23_linear_324_11732)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M192.632 55.271L78.6426 219.789L127.833 238.927L192.632 263.89V55.271Z",
    fill: "url(#paint24_linear_324_11732)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M127.833 238.927L192.632 55.271L260.269 238.927",
    stroke: "#25938C",
    strokeWidth: 1.5,
    strokeLinejoin: "bevel"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_324_11732)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M245.605 128.192L192.512 52.3018L139.774 128.617L156.92 112.926L154.614 140.09L171.937 108.052V141.574L183.171 113.758L189.201 129.568L193.877 105.649L201.356 148.231L205.756 113.758L215.067 135.707L214.033 105.649L235.554 139.316L226.212 110.668L245.605 128.192Z",
    fill: "#FEFEFE"
  }))), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M189.201 129.568L193.877 105.649L192.512 52.3018L139.774 128.617L156.92 112.926L154.614 140.09L171.937 108.052V141.574L183.171 113.758L189.201 129.568Z",
    fill: "#C7DBF5"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M426.786 202.09L424.041 201.991L423.9 208.272L423.013 208.723L422.82 216.232L420.335 217.143L421.021 239.926L422.82 239.602L428.74 238.446L443.766 193.016L438.977 200.46L427.939 210.726L427.721 206.106L427.16 206.424L426.786 202.09Z",
    fill: "#AADBB7"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M426.786 202.09L424.041 201.991L423.9 208.272L423.013 208.723L422.82 216.232L420.335 217.143L421.021 239.926L422.82 239.602L428.74 238.446L443.766 193.016L438.977 200.46L427.939 210.726L427.721 206.106L427.16 206.424L426.786 202.09Z",
    fill: "url(#paint25_linear_324_11732)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M426.88 202H424.05L423.9 208.272L423.012 208.743L422.823 216.062L420.314 217.139L421.021 239.926L422.82 239.602L422.627 225.87L428.242 217.143L438.977 200.46L427.939 210.726L427.703 206.134L427.16 206.424L426.88 202Z",
    fill: "#48A7A1"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M422.82 239.602L422.627 225.87L428.242 217.143L438.977 200.46L427.939 210.726L428.242 217.143L422.627 225.87L422.823 216.062L420.314 217.139L421.021 239.926L422.82 239.602Z",
    fill: "#48A7A1"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M422.82 239.602L422.627 225.87L428.242 217.143L438.977 200.46L429.052 214.679L428.731 209.989L427.939 210.726L428.181 215.847L422.627 223.289L422.82 216.038L421.577 216.591L422.242 239.706L422.82 239.602Z",
    fill: "#25938C"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M427.16 206.424L423.9 208.272L423.912 207.752L427.125 205.875L427.16 206.424Z",
    fill: "#25938C"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M426.651 202L436.634 195.175L438.672 184.29L436.125 177.873L434.342 181.466L429.707 173.766L428.23 175.819L427.211 174.023L423.391 178.216L423.136 176.769H421.098L415.495 187.113L424.206 202H426.651Z",
    fill: "#F6E4A1"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M428.23 175.819L423.9 181.466L423.391 178.216L427.211 174.023L428.23 175.819Z",
    fill: "#EBC644"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M424.16 202H426.605L428.171 200.929L424.536 201.279L425.781 198.898L434.296 181.466L433.675 180.434L426.069 197.136L424.646 180.434L428.184 175.819L428.043 175.571L424.532 179.496L424.252 177.197L423.345 178.216L423.692 180.434L423.854 181.466L425.733 198.463L423.889 201.538L424.16 202Z",
    fill: "#EBC644"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M501.463 194.122L499.286 194.043L499.175 198.992L498.471 199.348L498.318 205.264L496.347 205.982L496.891 223.932L498.318 223.677L503.013 222.766L514.93 186.973L511.132 192.837L502.378 200.926L502.205 197.286L501.76 197.536L501.463 194.122Z",
    fill: "#AADBB7"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M501.463 194.122L499.286 194.043L499.175 198.992L498.471 199.348L498.318 205.264L496.347 205.982L496.891 223.932L498.318 223.677L503.013 222.766L514.93 186.973L511.132 192.837L502.378 200.926L502.205 197.286L501.76 197.536L501.463 194.122Z",
    fill: "url(#paint26_linear_324_11732)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M501.538 194.05H499.293L499.175 198.992L498.47 199.364L498.321 205.13L496.331 205.978L496.891 223.932L498.318 223.677L498.165 212.857L502.618 205.982L511.132 192.837L502.378 200.926L502.191 197.308L501.76 197.536L501.538 194.05Z",
    fill: "#48A7A1"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M498.318 223.677L498.165 212.857L502.618 205.982L511.132 192.837L502.378 200.926L502.618 205.982L498.165 212.857L498.321 205.13L496.331 205.978L496.891 223.932L498.318 223.677Z",
    fill: "#48A7A1"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M498.318 223.677L498.165 212.857L502.618 205.982L511.132 192.837L503.261 204.04L503.006 200.346L502.378 200.926L502.57 204.96L498.165 210.824L498.318 205.111L497.333 205.546L497.859 223.759L498.318 223.677Z",
    fill: "#25938C"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M501.76 197.536L499.175 198.992L499.184 198.583L501.732 197.104L501.76 197.536Z",
    fill: "#25938C"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M501.356 194.05L509.274 188.673L510.89 180.097L508.87 175.041L507.456 177.872L503.78 171.806L502.608 173.423L501.8 172.008L498.771 175.312L498.569 174.171H496.953L492.509 182.321L499.417 194.05H501.356Z",
    fill: "#F6E4A1"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M502.608 173.423L499.175 177.872L498.771 175.312L501.8 172.008L502.608 173.423Z",
    fill: "#EBC644"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M499.381 194.05H501.32L502.562 193.207L499.679 193.482L500.666 191.606L507.42 177.872L506.927 177.059L500.895 190.219L499.766 177.059L502.572 173.423L502.46 173.228L499.675 176.32L499.454 174.509L498.734 175.312L499.01 177.059L499.138 177.872L500.628 191.263L499.166 193.686L499.381 194.05Z",
    fill: "#EBC644"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M302.204 219.724L300.121 219.648L300.015 224.407L299.341 224.749L299.195 230.438L297.31 231.128L297.83 248.387L299.195 248.142L303.686 247.267L315.085 212.85L311.452 218.489L303.079 226.266L302.913 222.766L302.488 223.007L302.204 219.724Z",
    fill: "#AADBB7"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M302.204 219.724L300.121 219.648L300.015 224.407L299.341 224.749L299.195 230.438L297.31 231.128L297.83 248.387L299.195 248.142L303.686 247.267L315.085 212.85L311.452 218.489L303.079 226.266L302.913 222.766L302.488 223.007L302.204 219.724Z",
    fill: "url(#paint27_linear_324_11732)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M302.275 219.655H300.128L300.015 224.407L299.341 224.764L299.198 230.308L297.294 231.124L297.83 248.387L299.195 248.142L299.049 237.739L303.308 231.128L311.452 218.489L303.079 226.266L302.9 222.787L302.488 223.007L302.275 219.655Z",
    fill: "#48A7A1"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M299.195 248.142L299.049 237.739L303.308 231.128L311.452 218.489L303.079 226.266L303.308 231.128L299.049 237.739L299.198 230.308L297.294 231.124L297.83 248.387L299.195 248.142Z",
    fill: "#48A7A1"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M299.195 248.142L299.049 237.739L303.308 231.128L311.452 218.489L303.923 229.261L303.68 225.708L303.079 226.266L303.262 230.145L299.049 235.783L299.195 230.291L298.253 230.709L298.757 248.221L299.195 248.142Z",
    fill: "#25938C"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M302.488 223.007L300.015 224.407L300.024 224.013L302.461 222.591L302.488 223.007Z",
    fill: "#25938C"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M302.101 219.655L309.675 214.485L311.221 206.238L309.289 201.377L307.936 204.099L304.42 198.266L303.299 199.822L302.526 198.461L299.628 201.637L299.435 200.541H297.889L293.639 208.377L300.246 219.655H302.101Z",
    fill: "#D2D4F8"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M303.299 199.822L300.015 204.099L299.628 201.637L302.526 198.461L303.299 199.822Z",
    fill: "#A491DD"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M300.212 219.655H302.066L303.255 218.844L300.497 219.109L301.441 217.305L307.901 204.099L307.43 203.317L301.66 215.971L300.58 203.317L303.264 199.822L303.157 199.633L300.494 202.607L300.281 200.865L299.593 201.637L299.857 203.317L299.98 204.099L301.405 216.976L300.006 219.305L300.212 219.655Z",
    fill: "#A491DD"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M287.808 219.608L290.648 219.506L290.793 225.977L291.711 226.442L291.91 234.179L294.481 235.117L293.771 258.59L291.91 258.257L285.787 257.066L270.242 210.259L275.197 217.928L286.615 228.506L286.841 223.746L287.42 224.073L287.808 219.608Z",
    fill: "#AADBB7"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M287.808 219.608L290.648 219.506L290.793 225.977L291.711 226.442L291.91 234.179L294.481 235.117L293.771 258.59L291.91 258.257L285.787 257.066L270.242 210.259L275.197 217.928L286.615 228.506L286.841 223.746L287.42 224.073L287.808 219.608Z",
    fill: "url(#paint28_linear_324_11732)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M287.711 219.515H290.638L290.793 225.977L291.712 226.463L291.907 234.003L294.503 235.113L293.771 258.59L291.91 258.257L292.11 244.108L286.301 235.117L275.197 217.928L286.615 228.506L286.859 223.774L287.42 224.073L287.711 219.515Z",
    fill: "#48A7A1"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M291.91 258.257L292.11 244.108L286.301 235.117L275.197 217.928L286.615 228.506L286.301 235.117L292.11 244.108L291.907 234.003L294.503 235.113L293.771 258.59L291.91 258.257Z",
    fill: "#48A7A1"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M291.91 258.257L292.11 244.108L286.301 235.117L275.197 217.928L285.463 232.578L285.795 227.747L286.615 228.506L286.365 233.782L292.11 241.449L291.91 233.979L293.196 234.548L292.509 258.364L291.91 258.257Z",
    fill: "#25938C"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M287.42 224.073L290.793 225.977L290.78 225.442L287.457 223.508L287.42 224.073Z",
    fill: "#25938C"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M287.948 219.515L277.62 212.483L275.512 201.268L278.147 194.657L279.991 198.359L284.786 190.426L286.314 192.541L287.368 190.69L291.32 195.011L291.584 193.519H293.691L299.488 204.177L290.477 219.515H287.948Z",
    fill: "#F6E4A1"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M286.314 192.541L290.793 198.359L291.32 195.011L287.368 190.69L286.314 192.541Z",
    fill: "#EBC644"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M290.525 219.515H287.995L286.375 218.412L290.135 218.772L288.848 216.319L280.038 198.359L280.681 197.296L288.549 214.504L290.022 197.296L286.362 192.541L286.508 192.285L290.14 196.329L290.429 193.961L291.368 195.011L291.008 197.296L290.841 198.359L288.897 215.871L290.804 219.039L290.525 219.515Z",
    fill: "#EBC644"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M486.468 182.547L488.834 182.462L488.955 187.886L489.72 188.276L489.886 194.761L492.029 195.548L491.437 215.224L489.886 214.944L484.783 213.946L471.829 174.711L475.958 181.139L485.473 190.006L485.662 186.016L486.145 186.29L486.468 182.547Z",
    fill: "#AADBB7"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M486.468 182.547L488.834 182.462L488.955 187.886L489.72 188.276L489.886 194.761L492.029 195.548L491.437 215.224L489.886 214.944L484.783 213.946L471.829 174.711L475.958 181.139L485.473 190.006L485.662 186.016L486.145 186.29L486.468 182.547Z",
    fill: "url(#paint29_linear_324_11732)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M486.386 182.469H488.826L488.955 187.886L489.721 188.293L489.883 194.614L492.046 195.544L491.437 215.224L489.886 214.944L490.053 203.085L485.212 195.548L475.958 181.139L485.473 190.006L485.677 186.04L486.145 186.29L486.386 182.469Z",
    fill: "#48A7A1"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M489.886 214.944L490.053 203.085L485.212 195.548L475.958 181.139L485.473 190.006L485.212 195.548L490.053 203.085L489.883 194.614L492.046 195.544L491.437 215.224L489.886 214.944Z",
    fill: "#48A7A1"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M489.886 214.944L490.053 203.085L485.212 195.548L475.958 181.139L484.514 193.42L484.79 189.37L485.473 190.006L485.265 194.428L490.053 200.855L489.886 194.594L490.958 195.071L490.385 215.034L489.886 214.944Z",
    fill: "#25938C"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M486.145 186.29L488.955 187.886L488.945 187.437L486.175 185.816L486.145 186.29Z",
    fill: "#25938C"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M486.584 182.469L477.977 176.575L476.221 167.174L478.416 161.633L479.953 164.736L483.949 158.086L485.223 159.859L486.101 158.308L489.394 161.929L489.614 160.679H491.37L496.201 169.613L488.692 182.469H486.584Z",
    fill: "#D2D4F8"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M485.223 159.859L488.955 164.736L489.394 161.929L486.101 158.308L485.223 159.859Z",
    fill: "#A491DD"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M488.731 182.469H486.624L485.273 181.545L488.407 181.847L487.334 179.79L479.993 164.736L480.529 163.844L487.085 178.269L488.313 163.844L485.262 159.859L485.384 159.645L488.411 163.034L488.652 161.049L489.434 161.929L489.134 163.844L488.995 164.736L487.375 179.415L488.964 182.07L488.731 182.469Z",
    fill: "#A491DD"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6409 195.224L50.5587 195.148L50.4522 199.907L49.7788 200.249L49.6326 205.938L47.7472 206.628L48.2678 223.887L49.6326 223.642L54.1232 222.767L65.5227 188.35L61.8894 193.989L53.5159 201.766L53.3504 198.266L52.9253 198.507L52.6409 195.224Z",
    fill: "#AADBB7"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6409 195.224L50.5587 195.148L50.4522 199.907L49.7788 200.249L49.6326 205.938L47.7472 206.628L48.2678 223.887L49.6326 223.642L54.1232 222.767L65.5227 188.35L61.8894 193.989L53.5159 201.766L53.3504 198.266L52.9253 198.507L52.6409 195.224Z",
    fill: "url(#paint30_linear_324_11732)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7125 195.155H50.5655L50.4522 199.907L49.7783 200.264L49.6352 205.808L47.7316 206.624L48.2678 223.887L49.6326 223.642L49.4862 213.239L53.7459 206.628L61.8894 193.989L53.5159 201.766L53.337 198.287L52.9253 198.507L52.7125 195.155Z",
    fill: "#48A7A1"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6326 223.642L49.4862 213.239L53.7459 206.628L61.8894 193.989L53.5159 201.766L53.7459 206.628L49.4862 213.239L49.6352 205.808L47.7316 206.624L48.2678 223.887L49.6326 223.642Z",
    fill: "#48A7A1"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6326 223.642L49.4862 213.239L53.7459 206.628L61.8894 193.989L54.3606 204.761L54.1169 201.208L53.5159 201.766L53.6994 205.645L49.4862 211.283L49.6326 205.791L48.6899 206.209L49.1939 223.721L49.6326 223.642Z",
    fill: "#25938C"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9253 198.507L50.4522 199.907L50.4612 199.513L52.8983 198.091L52.9253 198.507Z",
    fill: "#25938C"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5386 195.155L60.1125 189.985L61.6582 181.738L59.7261 176.877L58.3736 179.599L54.8571 173.766L53.7365 175.322L52.9637 173.961L50.0655 177.137L49.8723 176.041H48.3266L44.0759 183.877L50.6838 195.155H52.5386Z",
    fill: "#D2D4F8"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7365 175.322L50.4519 179.599L50.0655 177.137L52.9636 173.961L53.7365 175.322Z",
    fill: "#A491DD"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6489 195.155H52.5037L53.6921 194.344L50.9347 194.609L51.8787 192.805L58.3387 179.599L57.8673 178.817L52.0977 191.471L51.0175 178.817L53.7016 175.322L53.5946 175.133L50.9309 178.107L50.7188 176.365L50.0306 177.137L50.2943 178.817L50.417 179.599L51.8422 192.476L50.4438 194.805L50.6489 195.155Z",
    fill: "#A491DD"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M36.492 183.534L39.5207 183.424L39.6756 190.371L40.6551 190.87L40.8678 199.176L43.6101 200.183L42.8529 225.382L40.8678 225.024L34.3359 223.746L17.7549 173.498L23.0397 181.73L35.2193 193.086L35.4601 187.976L36.0784 188.327L36.492 183.534Z",
    fill: "#AADBB7"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M36.492 183.534L39.5207 183.424L39.6756 190.371L40.6551 190.87L40.8678 199.176L43.6101 200.183L42.8529 225.382L40.8678 225.024L34.3359 223.746L17.7549 173.498L23.0397 181.73L35.2193 193.086L35.4601 187.976L36.0784 188.327L36.492 183.534Z",
    fill: "url(#paint31_linear_324_11732)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3879 183.434H39.5108L39.6756 190.371L40.6559 190.893L40.864 198.987L43.6328 200.179L42.8529 225.382L40.8678 225.024L41.0808 209.836L34.8848 200.183L23.0397 181.73L35.2193 193.086L35.4795 188.006L36.0784 188.327L36.3879 183.434Z",
    fill: "#48A7A1"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8678 225.024L41.0808 209.836L34.8848 200.183L23.0397 181.73L35.2193 193.086L34.8848 200.183L41.0808 209.836L40.864 198.987L43.6328 200.179L42.8529 225.382L40.8678 225.024Z",
    fill: "#48A7A1"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8678 225.024L41.0808 209.836L34.8848 200.183L23.0397 181.73L33.9906 197.458L34.3451 192.271L35.2193 193.086L34.9524 198.749L41.0808 206.981L40.8678 198.961L42.2389 199.572L41.5059 225.139L40.8678 225.024Z",
    fill: "#25938C"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0784 188.327L39.6756 190.371L39.6625 189.796L36.1176 187.72L36.0784 188.327Z",
    fill: "#25938C"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6409 183.434L25.6243 175.885L23.376 163.845L26.1864 156.748L28.1536 160.722L33.2685 152.206L34.8985 154.477L36.0226 152.489L40.2381 157.128L40.5192 155.526H42.7674L48.9502 166.968L39.3388 183.434H36.6409Z",
    fill: "#D2D4F8"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8985 154.477L39.6761 160.722L40.2381 157.128L36.0226 152.489L34.8985 154.477Z",
    fill: "#A491DD"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3895 183.434H36.6916L34.963 182.249L38.9738 182.636L37.6007 180.002L28.2044 160.722L28.8901 159.581L37.2822 178.054L38.8534 159.581L34.9492 154.477L35.1048 154.202L38.9793 158.543L39.2878 156L40.2889 157.128L39.9053 159.581L39.7268 160.722L37.6537 179.521L39.6879 182.923L39.3895 183.434Z",
    fill: "#A491DD"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M222.689 258.994L225.718 258.884L225.873 265.832L226.852 266.331L227.065 274.637L229.807 275.644L229.05 300.843L227.065 300.485L220.533 299.207L203.952 248.958L209.237 257.191L221.416 268.547L221.657 263.436L222.275 263.788L222.689 258.994Z",
    fill: "#AADBB7"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M222.689 258.994L225.718 258.884L225.873 265.832L226.852 266.331L227.065 274.637L229.807 275.644L229.05 300.843L227.065 300.485L220.533 299.207L203.952 248.958L209.237 257.191L221.416 268.547L221.657 263.436L222.275 263.788L222.689 258.994Z",
    fill: "url(#paint32_linear_324_11732)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M222.585 258.894H225.708L225.873 265.832L226.853 266.353L227.061 274.448L229.83 275.639L229.05 300.843L227.065 300.485L227.278 285.296L221.082 275.644L209.237 257.191L221.416 268.547L221.677 263.467L222.275 263.788L222.585 258.894Z",
    fill: "#48A7A1"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M227.065 300.485L227.278 285.296L221.082 275.644L209.237 257.191L221.416 268.547L221.082 275.644L227.278 285.296L227.061 274.448L229.83 275.639L229.05 300.843L227.065 300.485Z",
    fill: "#48A7A1"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M227.065 300.485L227.278 285.296L221.082 275.644L209.237 257.191L220.188 272.918L220.542 267.731L221.416 268.547L221.15 274.21L227.278 282.441L227.065 274.422L228.436 275.033L227.703 300.6L227.065 300.485Z",
    fill: "#25938C"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M222.275 263.788L225.873 265.832L225.86 265.257L222.315 263.18L222.275 263.788Z",
    fill: "#25938C"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M222.838 258.894L211.821 251.345L209.573 239.306L212.384 232.208L214.351 236.183L219.466 227.666L221.096 229.937L222.22 227.95L226.435 232.588L226.716 230.987H228.965L235.147 242.428L225.536 258.894H222.838Z",
    fill: "#FBE6DC"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M221.096 229.937L225.873 236.183L226.435 232.588L222.22 227.95L221.096 229.937Z",
    fill: "#FFB1B1"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M225.587 258.894H222.889L221.16 257.71L225.171 258.097L223.798 255.463L214.401 236.183L215.087 235.041L223.479 253.515L225.05 235.041L221.146 229.937L221.302 229.662L225.176 234.003L225.485 231.461L226.486 232.588L226.102 235.041L225.924 236.183L223.851 254.982L225.885 258.383L225.587 258.894Z",
    fill: "#FFB1B1"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M341.005 125.579L339.206 125.514L339.114 129.606L338.533 129.9L338.407 134.793L336.778 135.386L337.228 150.229L338.407 150.018L342.285 149.266L352.13 119.667L348.992 124.516L341.76 131.205L341.617 128.195L341.25 128.402L341.005 125.579Z",
    fill: "#AADBB7"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M341.005 125.579L339.206 125.514L339.114 129.606L338.533 129.9L338.407 134.793L336.778 135.386L337.228 150.229L338.407 150.018L342.285 149.266L352.13 119.667L348.992 124.516L341.76 131.205L341.617 128.195L341.25 128.402L341.005 125.579Z",
    fill: "url(#paint33_linear_324_11732)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M341.066 125.52H339.212L339.114 129.606L338.532 129.913L338.409 134.682L336.765 135.383L337.228 150.229L338.407 150.018L338.28 141.072L341.959 135.386L348.992 124.516L341.76 131.205L341.606 128.213L341.25 128.402L341.066 125.52Z",
    fill: "#48A7A1"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M338.407 150.018L338.28 141.072L341.959 135.386L348.992 124.516L341.76 131.205L341.959 135.386L338.28 141.072L338.409 134.682L336.765 135.383L337.228 150.229L338.407 150.018Z",
    fill: "#48A7A1"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M338.407 150.018L338.28 141.072L341.959 135.386L348.992 124.516L342.49 133.781L342.279 130.725L341.76 131.205L341.919 134.541L338.28 139.39L338.407 134.666L337.592 135.026L338.028 150.086L338.407 150.018Z",
    fill: "#25938C"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M341.25 128.402L339.114 129.606L339.122 129.268L341.227 128.045L341.25 128.402Z",
    fill: "#25938C"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M340.916 125.52L347.457 121.073L348.792 113.981L347.124 109.801L345.956 112.142L342.919 107.125L341.951 108.463L341.283 107.292L338.78 110.024L338.614 109.081H337.279L333.608 115.821L339.314 125.52H340.916Z",
    fill: "#FBE6DC"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M341.951 108.463L339.114 112.142L338.78 110.024L341.283 107.292L341.951 108.463Z",
    fill: "#FFB1B1"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M339.284 125.52H340.886L341.913 124.822L339.531 125.05L340.346 123.498L345.926 112.142L345.518 111.469L340.536 122.351L339.603 111.469L341.921 108.463L341.828 108.301L339.528 110.858L339.345 109.36L338.75 110.024L338.978 111.469L339.084 112.142L340.315 123.215L339.107 125.219L339.284 125.52Z",
    fill: "#FFB1B1"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M246.235 249.386L242.355 249.245L242.156 258.191L240.901 258.833L240.629 269.528L237.115 270.825L238.085 303.273L240.629 302.812L248.998 301.167L270.242 236.463L263.471 247.064L247.866 261.686L247.557 255.106L246.765 255.559L246.235 249.386Z",
    fill: "#AADBB7"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M246.235 249.386L242.355 249.245L242.156 258.191L240.901 258.833L240.629 269.528L237.115 270.825L238.085 303.273L240.629 302.812L248.998 301.167L270.242 236.463L263.471 247.064L247.866 261.686L247.557 255.106L246.765 255.559L246.235 249.386Z",
    fill: "url(#paint34_linear_324_11732)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M246.368 249.257H242.367L242.156 258.191L240.9 258.862L240.633 269.285L237.086 270.819L238.085 303.273L240.629 302.812L240.356 283.254L248.294 270.825L263.471 247.064L247.866 261.686L247.532 255.145L246.765 255.559L246.368 249.257Z",
    fill: "#48A7A1"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M240.629 302.812L240.356 283.254L248.294 270.825L263.471 247.064L247.866 261.686L248.294 270.825L240.356 283.254L240.633 269.285L237.086 270.819L238.085 303.273L240.629 302.812Z",
    fill: "#48A7A1"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M240.629 302.812L240.356 283.254L248.294 270.825L263.471 247.064L249.44 267.316L248.986 260.637L247.866 261.686L248.208 268.979L240.356 279.578L240.629 269.252L238.872 270.039L239.811 302.96L240.629 302.812Z",
    fill: "#25938C"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M246.765 255.559L242.156 258.191L242.173 257.45L246.715 254.777L246.765 255.559Z",
    fill: "#25938C"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M246.044 249.257L260.159 239.537L263.04 224.034L259.439 214.895L256.919 220.013L250.365 209.046L248.277 211.97L246.837 209.411L241.435 215.384L241.075 213.322H238.195L230.273 228.055L242.588 249.257H246.044Z",
    fill: "#FBE6DC"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M248.277 211.97L242.156 220.013L241.435 215.384L246.837 209.411L248.277 211.97Z",
    fill: "#FFB1B1"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M242.523 249.257H245.979L248.194 247.732L243.055 248.23L244.815 244.839L256.854 220.013L255.975 218.542L245.223 242.331L243.21 218.542L248.212 211.97L248.013 211.616L243.048 217.206L242.653 213.932L241.37 215.384L241.862 218.542L242.091 220.013L244.747 244.22L242.14 248.599L242.523 249.257Z",
    fill: "#FFB1B1"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M520.371 179.979L517.627 179.878L517.486 186.254L516.599 186.713L516.406 194.336L513.921 195.26L514.607 218.388L516.406 218.059L522.325 216.886L537.352 170.768L532.563 178.324L521.525 188.746L521.307 184.056L520.746 184.378L520.371 179.979Z",
    fill: "#AADBB7"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M520.371 179.979L517.627 179.878L517.486 186.254L516.599 186.713L516.406 194.336L513.921 195.26L514.607 218.388L516.406 218.059L522.325 216.886L537.352 170.768L532.563 178.324L521.525 188.746L521.307 184.056L520.746 184.378L520.371 179.979Z",
    fill: "url(#paint35_linear_324_11732)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M520.466 179.887H517.636L517.486 186.254L516.598 186.733L516.409 194.162L513.9 195.256L514.607 218.388L516.406 218.059L516.213 204.119L521.828 195.26L532.563 178.324L521.525 188.746L521.289 184.084L520.746 184.378L520.466 179.887Z",
    fill: "#48A7A1"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M516.406 218.059L516.213 204.119L521.828 195.26L532.563 178.324L521.525 188.746L521.828 195.26L516.213 204.119L516.409 194.162L513.9 195.256L514.607 218.388L516.406 218.059Z",
    fill: "#48A7A1"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M516.406 218.059L516.213 204.119L521.828 195.26L532.563 178.324L522.638 192.758L522.317 187.998L521.525 188.746L521.767 193.944L516.213 201.499L516.406 194.138L515.163 194.699L515.828 218.165L516.406 218.059Z",
    fill: "#25938C"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M520.746 184.378L517.486 186.254L517.498 185.727L520.711 183.821L520.746 184.378Z",
    fill: "#25938C"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M520.237 179.887L530.22 172.959L532.258 161.908L529.711 155.395L527.928 159.042L523.293 151.226L521.816 153.31L520.797 151.486L516.977 155.743L516.722 154.274H514.684L509.081 164.775L517.792 179.887H520.237Z",
    fill: "#FBE6DC"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M521.816 153.31L517.486 159.042L516.977 155.743L520.797 151.486L521.816 153.31Z",
    fill: "#FFB1B1"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M517.746 179.887H520.191L521.757 178.8L518.122 179.155L519.367 176.738L527.882 159.042L527.261 157.994L519.655 174.95L518.232 157.994L521.77 153.31L521.629 153.058L518.117 157.042L517.838 154.709L516.931 155.743L517.278 157.994L517.44 159.042L519.319 176.296L517.475 179.418L517.746 179.887Z",
    fill: "#FFB1B1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_324_11732",
    x: 135.775,
    y: 52.3018,
    width: 113.831,
    height: 103.93,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0705882 0 0 0 0 0.345098 0 0 0 0 0.403922 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_324_11732"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_324_11732",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_324_11732",
    x: 135.774,
    y: 52.3018,
    width: 113.831,
    height: 103.929,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0705882 0 0 0 0 0.345098 0 0 0 0 0.403922 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_324_11732"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_324_11732",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_324_11732",
    x1: 302.588,
    y1: 0.371331,
    x2: 302.588,
    y2: 299.896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.333333,
    stopColor: "#7DA7E7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7DA7E7",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_324_11732",
    x1: 250.05,
    y1: 308.028,
    x2: 292.857,
    y2: 429.408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_324_11732",
    x1: 276.8,
    y1: 117.014,
    x2: 276.8,
    y2: 307.164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AADBB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#D9E084"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9E084",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_324_11732",
    x1: 119.151,
    y1: 219.826,
    x2: 106.282,
    y2: 257.232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.489583,
    stopColor: "#48A7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48A7A1",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_324_11732",
    x1: 120.744,
    y1: 213.946,
    x2: 48.5496,
    y2: 390.608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.260417,
    stopColor: "#125867"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48A7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_324_11732",
    x1: 395.269,
    y1: 212.966,
    x2: 453.729,
    y2: 395.466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.286458,
    stopColor: "#48A7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AADBB7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_324_11732",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(274.198 443.327) rotate(90) scale(95.032 274.198)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBC644",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822917,
    stopColor: "#FBEFE7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_324_11732",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(308.474 136.506) rotate(90) scale(11.1149 37.5917)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48A7A1",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48A7A1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_324_11732",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(107.246 204.863) rotate(90) scale(10.5591 37.5917)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48A7A1",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48A7A1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_324_11732",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(163.08 182.077) rotate(90) scale(5.55743 20.4543)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48A7A1",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48A7A1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_324_11732",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(200.673 171.518) rotate(90) scale(6.11317 20.4543)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48A7A1",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48A7A1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_324_11732",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(437.28 199.86) rotate(90) scale(22.2297 77.9475)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6EC982",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.786458,
    stopColor: "#6EC982",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_324_11732",
    x1: 302.588,
    y1: 0.370843,
    x2: 302.588,
    y2: 299.895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.333333,
    stopColor: "#7DA7E7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7DA7E7",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_324_11732",
    x1: 302.588,
    y1: 0.370608,
    x2: 302.588,
    y2: 299.895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.333333,
    stopColor: "#7DA7E7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7DA7E7",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_324_11732",
    x1: 250.051,
    y1: 308.027,
    x2: 292.857,
    y2: 429.407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF6D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_324_11732",
    x1: 97.8069,
    y1: 164.829,
    x2: 107.85,
    y2: 199.968,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#AADBB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#25938C",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_324_11732",
    x1: 278.568,
    y1: 160.244,
    x2: 270.317,
    y2: 189.048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#AADBB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#25938C",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_324_11732",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(235.635 302.637) rotate(90) scale(6.37005 24.8588)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25938C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#25938C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_324_11732",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.6137 224.468) rotate(90) scale(6.37005 24.8588)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25938C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#25938C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_324_11732",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(294.126 255.106) rotate(-94.4884) scale(12.4567 48.6149)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25938C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#259385",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_324_11732",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(423.279 240.793) rotate(-93.5821) scale(10.8198 33.7506)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25938C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#259385",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_324_11732",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(496.757 222.379) rotate(80.7871) scale(10.9398 86.4856)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25938C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#259385",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_324_11732",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(342.021 148.206) rotate(-95.3007) scale(7.23768 33.3047)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25938C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#259385",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_324_11732",
    x1: 111.317,
    y1: 62.0012,
    x2: 193.372,
    y2: 263.589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#AADBB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48A7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_324_11732",
    x1: 201.226,
    y1: 58.6328,
    x2: 135.008,
    y2: 263.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#48A7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#125867"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_324_11732",
    x1: 432.05,
    y1: 193.016,
    x2: 418.779,
    y2: 239.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#AADBB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#25938C",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_324_11732",
    x1: 505.639,
    y1: 186.973,
    x2: 495.241,
    y2: 223.546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#AADBB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#25938C",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_324_11732",
    x1: 306.198,
    y1: 212.85,
    x2: 296.155,
    y2: 247.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#AADBB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#25938C",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_324_11732",
    x1: 282.362,
    y1: 210.259,
    x2: 295.989,
    y2: 258.068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#AADBB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#25938C",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_324_11732",
    x1: 481.929,
    y1: 174.711,
    x2: 493.409,
    y2: 214.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#AADBB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#25938C",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_324_11732",
    x1: 56.635,
    y1: 188.35,
    x2: 46.5922,
    y2: 223.489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#AADBB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#25938C",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_324_11732",
    x1: 30.6825,
    y1: 173.498,
    x2: 45.3915,
    y2: 224.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#AADBB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#25938C",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_324_11732",
    x1: 216.88,
    y1: 248.958,
    x2: 231.589,
    y2: 300.232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#AADBB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#25938C",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_324_11732",
    x1: 344.454,
    y1: 119.667,
    x2: 335.848,
    y2: 149.906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#AADBB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#25938C",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_324_11732",
    x1: 253.679,
    y1: 236.463,
    x2: 234.658,
    y2: 302.436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#AADBB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#25938C",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_324_11732",
    x1: 525.636,
    y1: 170.768,
    x2: 511.991,
    y2: 217.735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#AADBB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#25938C",
    stopOpacity: 0.3
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg);
export default __webpack_public_path__ + "static/media/bg.09c4c50b2dc28a493195f0c9220b846d.svg";
export { ForwardRef as ReactComponent };